module.exports = __webpack_public_path__ + "static/media/fotosport.c9ac90d5.webp";